import { ForgotPasswordForm } from "@/components/forgot-password-form"

export const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />
}
